import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { Flex } from 'reflexbox/styled-components'
import { Link } from 'react-router-dom'

import TextButton from 'components/TextButton'
import DataListingTable from 'components/DataListingTable'
import { SearchInput } from 'components/Form'
import ToggleBeneficiaryGroupStatusModal from 'components/Modal/ActivateGroupModal'

import { ActivateIcon, DeactivateIcon } from './styles'

import { DEFAULT_PAGE_SIZE } from 'constants/pagination'
import localStorage from 'helpers/localStorage'
import useDebounce from 'hooks/debounce'
import beneficiaryGroupsService from 'services/beneficiaryGroups'

const tableColumns = [
  {
    Header: 'ID',
    accessor: 'id',
  },
  {
    Header: 'Nome',
    accessor: 'name',
  },
  {
    Header: 'Beneficiários Ativos',
    accessor: 'active_beneficiaries_count',
    id: 'active_beneficiaries',
  },
  {
    Header: 'Pacotes de canais',
    accessor: 'packages',
    id: 'packages_count',
  },
  {
    Header: '',
    accessor: 'actions',
    disableSortBy: true,
  },
]

const BeneficiaryGroupsDataListing = () => {
  const [beneficiaryGroups, setBeneficiaryGroups] = useState([])
  const [sortBy, setSortBy] = useState(null)
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: localStorage.get('pageSize', DEFAULT_PAGE_SIZE),
    totalPages: 1,
    totalRecords: 0,
  })
  const [searchTerm, setSearchTerm] = useState(null)
  const [isLoading, setLoading] = useState(true)
  const [beneficiaryGroupToToggleStatus, setBeneficiaryGroupToToggleStatus] = useState(null)
  const [isToggleBeneficiaryGroupStatusModalOpen, setToggleBeneficiaryGroupStatusModalOpen] = useState(false)

  const debouncedSearchTerm = useDebounce(searchTerm, 500)

  const handleTableDataFetch = ({ sortBy, currentPage, pageSize }) => {
    setSortBy(sortBy)
    setPagination({ ...pagination, currentPage, pageSize })
  }

  const handleToggleBeneficiaryGroupStatusActionButtons = group => {
    setBeneficiaryGroupToToggleStatus(group)
    setToggleBeneficiaryGroupStatusModalOpen(true)
  }

  const handleToggleBeneficiaryGroupModalOpenState = isOpen => {
    setToggleBeneficiaryGroupStatusModalOpen(isOpen)

    if (!isOpen) {
      fetchBeneficiaryGroups()
    }
  }

  const fetchBeneficiaryGroups = async () => {
    setLoading(true)

    try {
      const response = await beneficiaryGroupsService.fetchAll({
        sortBy,
        pagination,
        search: debouncedSearchTerm,
      })

      const beneficiaryGroups = response.beneficiaryGroups.map(group => ({
        ...group,
        id: <Link to={`/prepaid-purchase/groups/attribution/${group.id}`}>{group.id}</Link>,
        actions: group.is_active ? (
          <TextButton variant='tertiary' onClick={() => handleToggleBeneficiaryGroupStatusActionButtons(group)}>
            <DeactivateIcon />
            Inativar
          </TextButton>
        ) : (
          <TextButton onClick={() => handleToggleBeneficiaryGroupStatusActionButtons(group)}>
            <ActivateIcon />
            Ativar
          </TextButton>
        ),
      }))

      setBeneficiaryGroups(beneficiaryGroups)
      setPagination(response.pagination)
    } catch (e) {
      console.log(e)
      toast.error('Ocorreu algum erro no carregamento dos dados')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (sortBy) {
      fetchBeneficiaryGroups()
    }
  }, [sortBy, pagination.currentPage, pagination.pageSize])

  useEffect(() => {
    if (pagination.currentPage === 1 && debouncedSearchTerm) {
      fetchBeneficiaryGroups()
    }
    setPagination({ ...pagination, currentPage: 1 })
  }, [debouncedSearchTerm])

  useEffect(() => {
    localStorage.set('pageSize', pagination.pageSize)
  }, [pagination.pageSize])

  return (
    <>
      <Flex flexDirection='column'>
        <Flex alignItems='center' justifyContent='flex-start' mb={24}>
          <SearchInput
            name='search'
            label='Buscar'
            placeholder='Buscar'
            onChange={e => setSearchTerm(e.target.value)}
            mr={24}
          />
        </Flex>
        <DataListingTable
          data={beneficiaryGroups}
          columns={tableColumns}
          pagination={pagination}
          loading={isLoading}
          fetchData={handleTableDataFetch}
        />
      </Flex>
      <ToggleBeneficiaryGroupStatusModal
        isOpened={isToggleBeneficiaryGroupStatusModalOpen}
        setIsOpened={handleToggleBeneficiaryGroupModalOpenState}
        group={beneficiaryGroupToToggleStatus}
      />
    </>
  )
}

export default BeneficiaryGroupsDataListing
